import axios from 'axios'

const getSupervisor = async (supervisorId) => {
  return await axios({
    url: `/api/supervisor/${supervisorId}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      authorization: window.localStorage.getItem('ngStorage-accessToken')
    }
  })
}

export default getSupervisor
